import { render } from "./CampaignItem.vue?vue&type=template&id=270bf14d"
import script from "./CampaignItem.vue?vue&type=script&lang=js"
export * from "./CampaignItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__